import { createLayoutApp } from "../layout/createLayoutApp";
import { setDocumentControllerType } from "../util/controllerHelpers";
import HotelDirectoryApp from "../hotelDirectory/HotelDirectoryApp.vue";

const mountEl = document.getElementById("hotel-directory-app");
if (mountEl && mountEl.getAttribute("data-vue3") === "true") {
  setDocumentControllerType("desktop");
  const viewModelJson = mountEl.getAttribute("data-view-model");
  const viewModel = viewModelJson ? JSON.parse(viewModelJson) : null;
  const app = createLayoutApp(HotelDirectoryApp, { viewModel });
  app.config.globalProperties.$mobile = false;
  app.mount(mountEl);
}
